var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVigyanVrikshVideoLecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.icon-image-layer3{fill:none;stroke:currentcolor;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer3",
    d: "M96.7,16.1L76.3,44c-0.4,0.5-0.9,1-1.5,1.3l-12.1,7c-0.6,0.3-1.3-0.2-1.1-0.8l2.8-13.8c0.1-0.7,0.4-1.3,0.8-1.9L85.6,7.9c2.2-3.1,6.5-3.7,9.6-1.5l0,0C98.2,8.7,98.9,13,96.7,16.1z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "icon-image-layer3",
    x1: 75,
    y1: 44.3,
    x2: 68.7,
    y2: 39.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer3",
    d: "M75.2,7.4H9.7c-3.9,0-7,3.1-7,7v57.1c0,3.9,3.1,7,7,7h74.8c3.9,0,7-3.1,7-7V36.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "icon-image-layer3",
    x1: 61.4,
    y1: 95,
    x2: 57.2,
    y2: 78.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "icon-image-layer3",
    x1: 32.8,
    y1: 95,
    x2: 37,
    y2: 78.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "icon-image-layer3",
    x1: 26.8,
    y1: 95.9,
    x2: 67.4,
    y2: 95.9
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "icon-image-layer3",
    d: "M10.3,18.1v45.7c0,0.6,0.5,1.2,1.2,1.2h71.2c0.6,0,1.2-0.5,1.2-1.2V49.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigyanVrikshVideoLecture);
export default __webpack_public_path__ + "static/media/vigyan-vriksh-video-lecture.5ff29f6fda7c035decd49788a6c787f7.svg";
export { ForwardRef as ReactComponent };